import React from 'react';
import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';

export const Container = styled.div`
  z-index: 100;
  left: 0;
  height: 60px;
  background: linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  border-bottom: 1px solid rgba(244, 241, 222, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.05) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 4px,
        rgba(244, 241, 222, 0.02) 4px,
        rgba(244, 241, 222, 0.02) 6px
      );
    pointer-events: none;
    z-index: 0;
  }

  @media (max-width: 768px) {
    height: 60px;
    padding: 0 15px;
    flex-direction: row;
  }

  @media (max-width: 550px) {
    padding: 0 10px;
  }

  @media (max-width: 470px) {
    height: 60px;
    padding: 0 8px;
    flex-direction: row;
  }
`;

export const ProfileBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: calc(100% - ${props => props.isCollapsed ? '50px' : '279px'});
  height: 60px;
  padding-left: 10px;
  padding-right: 10px;
  transition: width 0.3s ease;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0;
    padding-right: 10px;
    justify-content: flex-end;
    gap: 15px;
  }

  @media (max-width: 550px) {
    gap: 10px;
    padding-right: 10px;
  }

  @media (max-width: 470px) {
    width: 100%;
    padding-left: 0;
    padding-right: 10px;
    justify-content: flex-end;
    gap: 8px;
  }

  > div:first-child {
    @media (max-width: 768px) {
      display: none;
    }

    display: flex;
    flex-direction: column;
    gap: 4px;

    h4 {
      color: #f4f1de;
      font-weight: 600;
      margin: 0;
      font-size: 16px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    span {
      color: rgba(244, 241, 222, 0.8);
      font-size: 14px;
      font-weight: 400;
      margin-top: 2px;
    }
  }
`;

export const UserMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h4 {
    color: #f4f1de;
    font-weight: 600;
    margin: 0;
    font-size: 16px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
`;

export const UserRole = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(244, 241, 222, 0.9);
  font-size: 13px;
  font-weight: 500;
  margin-top: 2px;

  svg {
    opacity: 0.8;
  }
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;

  span {
    color: rgba(244, 241, 222, 0.8);
    font-size: 14px;
    font-weight: 400;
  }
`;

export const OrganizationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(244, 241, 222, 0.7);
  font-size: 13px;
  font-weight: 400;

  svg {
    opacity: 0.7;
  }
`;

export const DropdownUserHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(244, 241, 222, 0.1);
  margin-bottom: 8px;

  #dropdown-user-name {
    color: #f4f1de;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 4px;
  }

  #dropdown-user-role {
    color: rgba(244, 241, 222, 0.9);
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 6px;
  }

  #dropdown-user-email {
    color: rgba(244, 241, 222, 0.8);
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 8px;
  }

  #dropdown-organization {
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(244, 241, 222, 0.7);
    font-size: 13px;
    font-weight: 400;

    svg {
      opacity: 0.7;
    }
  }
`;

export const AvatarFallback = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid rgba(244, 241, 222, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f4f1de;
  font-weight: 600;
  font-size: 18px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, rgba(244, 241, 222, 0.8), rgba(244, 241, 222, 0.6), rgba(244, 241, 222, 0.4), rgba(244, 241, 222, 0.2));
    border-radius: 50%;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    border-color: rgba(244, 241, 222, 0.6);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    transform: scale(1.08);
    
    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-width: 2px;
    font-size: 16px;
  }

  @media (max-width: 550px) {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }

  @media (max-width: 470px) {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
`;

export const CustomProfileImg = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid rgba(244, 241, 222, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  object-fit: cover;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, rgba(244, 241, 222, 0.8), rgba(244, 241, 222, 0.6), rgba(244, 241, 222, 0.4), rgba(244, 241, 222, 0.2));
    border-radius: 50%;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    border-color: rgba(244, 241, 222, 0.6);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    transform: scale(1.08);
    
    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-width: 2px;
  }

  @media (max-width: 550px) {
    width: 35px;
    height: 35px;
  }

  @media (max-width: 470px) {
    width: 32px;
    height: 32px;
  }
`;

export const CustomDropdownToggle = styled(Dropdown.Toggle)`
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    display: none !important;
  }

  &:focus {
    box-shadow: none !important;
    background: transparent !important;
  }

  &:hover {
    background: transparent !important;
  }

  &:active {
    background: transparent !important;
  }

  /* Adiciona um indicador sutil de que é clicável */
  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border-radius: 50%;
    background: rgba(244, 241, 222, 0.1);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  &:hover::before {
    opacity: 1;
  }
`;

export const LogoBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  width: ${props => props.isCollapsed ? '50px' : '279px'};
  gap: ${props => props.isCollapsed ? '0px' : '25px'};
  transition: width 0.3s ease, gap 0.3s ease;
  overflow: hidden;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(244, 241, 222, 0.05);
    backdrop-filter: blur(10px);
    z-index: -1;
  }

  @media (max-width: 768px) {
    width: auto;
    border-right: none;
    padding: 0;
    gap: 15px;
    min-width: auto;
  }

  @media (max-width: 550px) {
    gap: 10px;
  }

  @media (max-width: 470px) {
    width: auto;
    border-right: none;
    padding: 0;
    gap: 8px;
    min-width: auto;
  }

  img {
    width: ${props => props.isCollapsed ? '0px' : '150px'};
    opacity: ${props => props.isCollapsed ? '0' : '1'};
    transition: width 0.3s ease, opacity 0.3s ease;
    min-width: ${props => props.isCollapsed ? '0px' : '150px'};
    visibility: ${props => props.isCollapsed ? 'hidden' : 'visible'};
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));

    @media (max-width: 768px) {
      width: 120px;
      min-width: 120px;
      opacity: 1;
      visibility: visible;
    }

    @media (max-width: 550px) {
      width: 100px;
      min-width: 100px;
    }

    @media (max-width: 470px) {
      width: 80px;
      min-width: 80px;
    }
  }
`;

export const CustomDropdownMenu = styled(Dropdown.Menu)`
  position: absolute !important;
  inset: -1px 5px auto auto !important;
  background: rgba(26, 26, 46, 0.95) !important;
  backdrop-filter: blur(15px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 12px;
  z-index: 1000;
  border: 1px solid rgba(244, 241, 222, 0.2);

  .dropdown-item {
    color: #f4f1de !important;
    border-radius: 8px;
    margin: 2px 0;
    padding: 8px 12px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(244, 241, 222, 0.1) !important;
      color: #f4f1de !important;
      transform: translateX(4px);
    }

    &:active {
      background: rgba(244, 241, 222, 0.15) !important;
    }

    /* Estilo especial para o item de logout */
    &#user-logout-option {
      &:hover {
        background: rgba(220, 53, 69, 0.1) !important;
        color: #dc3545 !important;
        
        span {
          color: #dc3545 !important;
        }
      }
      
      span {
        color: rgba(220, 53, 69, 0.8);
        transition: color 0.3s ease;
      }
    }

    span {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 500;

      svg {
        font-size: 16px;
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 768px) {
    inset: -1px 0px auto auto !important;
    min-width: 200px;
  }

  @media (max-width: 550px) {
    min-width: 180px;
    padding: 10px;
  }

  @media (max-width: 470px) {
    min-width: 160px;
    padding: 8px;
  }
`;

export const ToggleButtonBox = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: ${props => props.isCollapsed ? 'center' : 'flex-start'};
  width: ${props => props.isCollapsed ? '100%' : 'auto'};

  @media (max-width: 768px) {
    justify-content: flex-start;
    width: auto;
  }

  @media (max-width: 470px) {
    justify-content: flex-start;
    width: auto;
  }
`;

export const ToggleButton = styled.button`
  background: rgba(244, 241, 222, 0.1);
  border: 1px solid rgba(244, 241, 222, 0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  color: #f4f1de;
  border-radius: 6px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  min-width: 32px;
  min-height: 32px;

  &:hover {
    background: rgba(244, 241, 222, 0.2);
    border-color: rgba(244, 241, 222, 0.4);
    color: #f4f1de;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    svg {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    transition: all 0.3s ease;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
    font-size: 18px;

    @media (max-width: 768px) {
      font-size: 16px;
    }

    @media (max-width: 550px) {
      font-size: 14px;
    }

    @media (max-width: 470px) {
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    padding: 4px;
    min-width: 28px;
    min-height: 28px;
    background: rgba(244, 241, 222, 0.15);
    border-radius: 5px;
  }

  @media (max-width: 470px) {
    padding: 3px;
    min-width: 24px;
    min-height: 24px;
    background: rgba(244, 241, 222, 0.15);
    border-radius: 5px;
  }
`;